/** Add a short cache-busting version to a stable public asset URL. */
export function nextAssetVersionUrl(assetUrl: string, currentUrl?: string | null): string {
  let version = 1

  if (currentUrl) {
    try {
      const currentVersion = Number.parseInt(new URL(currentUrl).searchParams.get('v') ?? '', 10)
      if (Number.isSafeInteger(currentVersion) && currentVersion > 0) version = currentVersion + 1
    } catch {
      // Old or malformed URLs have no usable version; start at v=1.
    }
  }

  const nextUrl = new URL(assetUrl)
  nextUrl.searchParams.set('v', String(version))
  return nextUrl.toString()
}
